exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sent-projects-list .project-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n}\n.sent-projects-list .project-title > i.left-offset {\n  display: inline-block;\n}\n", ""]);

